"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isRaffleWinner(object) {
    return checkRaffleWinner(object).fulfilled;
}
exports.isRaffleWinner = isRaffleWinner;
function checkRaffleWinner(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("ticketId"), __1.hasNumber("winningRank").integer()).withOptions(options).explain();
}
exports.checkRaffleWinner = checkRaffleWinner;
//# sourceMappingURL=RaffleWinner.js.map